import * as XLSX from "xlsx";

import GetIcon from "Components/Global/Icons";

import { globalInterpreterForDate } from "./Format";

export const imageExtensions = ["jpeg", "png", "gif", "webp", "jpg"];
export const docExtensions = ["pdf", "ppt", "pptx"];
export const videoExtensions = ["mp4", "mov", "webm"];
export const audioExtensions = ["mp3", "wav", "ogg"];
export const documentExtensions = ["pdf"];
// Apresentação da seletiva: "formato livre" dentro do que o patrocinador
// consegue abrir (PowerPoint, Google Slides/Keynote exportados, Word, PDF).
export const presentationExtensions = [
  "pdf",
  "ppt",
  "pptx",
  "doc",
  "docx",
  "odp",
];
// Lista AMPLA do Álbum (D16 da parte 2, 03/09/2026) — espelha
// ALBUM_EXTENSIONS do backend (@/config/projectFileTypes). "Sem restrição de
// tipo" virou lista ampla: aceitar qualquer extensão transformaria o Álbum em
// hospedagem de binário arbitrário servida por URL assinada da plataforma.
// ⚠️ Divergir do backend dá 400 no upload, não erro de tela.
export const albumExtensions = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "webp",
  "svg",
  "heic",
  "mp4",
  "mov",
  "webm",
  "avi",
  "wmv",
  "mkv",
  "m4v",
  "mpeg",
  "mpg",
  "mp3",
  "wav",
  "ogg",
  "m4a",
  "aac",
  "flac",
  "pdf",
  "doc",
  "docx",
  "xls",
  "xlsx",
  "ppt",
  "pptx",
  "odt",
  "ods",
  "odp",
  "txt",
  "csv",
  "zip",
  "rar",
  "7z",
];

export const spreadsheetExtensions = [
  "application/vnd.ms-excel",
  "xlsx",
  "xlsb",
];

export const getFileContentType = (extension) => {
  switch (extension) {
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "jpg":
      return "image/jpeg";
    case "mp4":
      return "video/mp4";
    case "mov":
      return "video/quicktime";
    case "webm":
      return "video/webm";
    case "pdf":
      return "application/pdf";
    case "ppt":
      return "application/vnd.ms-powerpoint";
    case "pptx":
      return "application/octet-stream";
    case "xlsx":
    case "xlsxb":
      return "application/vnd.ms-excel";
    default:
      return "file";
  }
};

export const getMediaFileType = (file) => {
  const extension = file.split(".").pop().split("?")[0];

  switch (extension) {
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "tiff":
    case "webp":
    case "heif":
    case "svg":
    case "raw":
    case "jpg":
      return <img src={file} alt="filem" />;
    case "mp4":
    case "avi":
    case "mkv":
    case "webm":
    case "mvm":
    case "flv":
    case "divx":
    case "h264":
    case "mov":
      return (
        <video controls>
          <source src={file} type="video/mp4" />
        </video>
      );
    case "mp3":
    case "aac":
    case "flac":
    case "wav":
    case "aiff":
    case "alac":
    case "wma":
    case "ogg":
    case "dsd":
      return (
        <audio controls>
          <source src={file} type="audio/mpeg" />
        </audio>
      );

    default:
      return <GetIcon name="File" size="md" />;
  }
};

export const getMediaUrlFileType = (file) => {
  const extension = file.name.split(".").pop();

  switch (extension) {
    case "jpeg":
    case "png":
    case "gif":
    case "bmp":
    case "tiff":
    case "webp":
    case "heif":
    case "svg":
    case "raw":
    case "jpg":
      return <img src={URL.createObjectURL(file)} alt="filem" />;
    case "mp4":
    case "avi":
    case "mkv":
    case "webm":
    case "mvm":
    case "flv":
    case "divx":
    case "h264":
    case "mov":
      return (
        <video controls>
          <source src={URL.createObjectURL(file)} type="video/mp4" />
        </video>
      );
    case "mp3":
    case "aac":
    case "flac":
    case "wav":
    case "aiff":
    case "alac":
    case "wma":
    case "ogg":
    case "dsd":
      return (
        <audio controls>
          <source src={URL.createObjectURL(file)} type="audio/mpeg" />
        </audio>
      );
    case "application/vnd.ms-excel":
    case "xlsx":
    case "xlsb":
      return <GetIcon name="XLSX" size="lg" />;
    default:
      return <GetIcon name="File" size="md" />;
  }
};

export const downloadAsXlsx = (data, file_name) => {
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Planilha1");

  XLSX.writeFile(wb, `${file_name}.xlsx`);
};

export const generateXLSXModelForDownload = (
  columns,
  fileName,
  example_data,
) => {
  const finalModel = [];

  if (example_data && Array.isArray(example_data)) {
    example_data.forEach((item) => {
      const object = {};

      for (const column of columns)
        object[column.Header] =
          typeof column.accessor === "string"
            ? item[column.accessor]
            : column.accessor(item);

      finalModel.push(object);
    });
  } else {
    for (const column of columns) {
      if (finalModel[0]) finalModel[0][column.Header] = null;
      else finalModel.push({ [column.Header]: null });
    }
  }

  downloadAsXlsx(finalModel, fileName);
};

export const getJSONFromXLSXFile = (file, sheetName) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const workbook = XLSX.read(e.target.result, { type: "array" });
      const wsname = sheetName || workbook.SheetNames[0];
      const ws = workbook.Sheets[wsname];
      const data = XLSX.utils.sheet_to_json(ws);
      resolve(data);
    };
    reader.onerror = (e) => {
      reject(e);
    };
    reader.readAsArrayBuffer(file);
  });
};

export const transformXLSXJSONToColumns = (data, columns) => {
  const finalData = [];

  for (const row of data) {
    const finalRow = {};

    for (const column of columns)
      if (row[column.Header]) {
        let value = row[column.Header];

        if (column.type === "date") {
          const interpreted_date = globalInterpreterForDate(row[column.Header]);

          if (interpreted_date)
            value = interpreted_date.format(column.dateFormat || "YYYY-MM-DD");
        }

        finalRow[column.accessor] = value;
      }

    finalData.push(finalRow);
  }

  return finalData;
};
